// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./resources/assets/sass/front/unocms-v4/main.scss
// module id = 12
// module chunks = 0